import { render, staticRenderFns } from "./CPage.vue?vue&type=template&id=72edcc1a&scoped=true&"
import script from "./CPage.vue?vue&type=script&lang=ts&"
export * from "./CPage.vue?vue&type=script&lang=ts&"
import style0 from "./CPage.vue?vue&type=style&index=0&id=72edcc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72edcc1a",
  null
  
)

export default component.exports